import { HgSupportedLanguage } from '@smg-real-estate/domus';

/**
 *  For specific enums for the values you need to pass for tracking check
 *  https://docs.google.com/spreadsheets/d/1f90_U41depIwExovFHg1ACFUL0C9m5QSey64OU6H1Do/edit#gid=310863332
 */

export enum GTMPageFeatureId {
  INITIAL_PAGE_LOAD = 'p000',
  FAVOURITES_LINK_CLICKED = 'e021',
  UNDO_ACTION = 'e026',
  FAVOURITES_PAGE_LOAD = 'p006',
  FAVOURITES_LIST_ITEM_CLICKED = 'e025',
  LISTING_ADDED_TO_FAVOURITES = 'e020',
  LISTING_REMOVED_FROM_FAVOURITES = 'e024',
}

export enum GTMPageType {
  FRONTEND_TEMPLATE_PAGE = 'frontendTemplatePage',
  FAVOURITES_PAGE = 'favourites',
}

export enum GTMPageSubType {}

export enum GTMServingSystem {}

export enum EventLabel {
  TAB_NAVIGATION = 'tab_navigation',
  SIDEBAR = 'sidebar',
}

export enum InteractionEvent {
  LOAD = 'load',
  VIRTUAL_PAGEVIEW = 'virtual_pageview',
  GENERIC_INTERACTION = 'generic_interaction',
  FAVOURITES_SHOW = 'favourites_show',
  UNDO = 'undo',
  FAVOURITES_CLICKTHROUGH = 'favourites_clickthrough',
  FAVOURITES_REMOVE = 'favourites_remove',
  FOOTER_CLICK = 'footer_interaction',
  HEADER_CLICK = 'header_interaction',
  FAVOURITES_INTERACTION = 'favourites_interaction',
  OPEN_MY_ACCOUNT = 'open_my_account',
  FEATURE_DISPLAYED = 'feature_displayed',
  BUTTON_CLICK = 'button_click',
}

export enum InteractionContainerDetail {
  NOTIFICATION = 'notification',
  SYMBOL_AND_TEXT = 'symbolAndText',
  BUTTON = 'button',
}

export enum InteractionGoal {
  UNDO_FAVOURITE_REMOVAL = 'undo_removeFromFavourites',
  GO_TO_PDP = 'favourites_goToPDP',
  ADD_TO_FAVOURITES = 'addToFavourites',
  REMOVE_FROM_FAVOURITES = 'removeFromFavourites',
  GO_TO_FAVOURITES = 'goToFavourites',
  OPEN_FAVOURITES = 'open_favourites',
  ADD_NOTE = 'add_note',
  SAVE_NOTE = 'save_note',
  EDIT_NOTE = 'edit_note',
  DELETE_NOTE = 'delete_note',
  DELETE_NOTE_TRIAL = 'delete_note_trial',
  OPEN_FORM_LEAD = 'open_formlead_modal',
  HOW_CTA_IMPRESSION = 'how_cta_impression',
  HOW_CTA_ADD_PROPERTY = 'how_cta_add_property',
  HOW_CTA_LEARN_MORE = 'how_cta_learn_more',
  HOW_DISPLAY_PROPERTY_OWNERSHIP_QUESTION = 'display_property_ownership_question',
  HOW_INPUT_IS_PROPERTY_OWNER = 'input_is_property_owner',
  HOW_DISPLAY_HOMEOWNER_BANNER = 'display_homeowner_banner',
  HOW_GO_TO_VALUATION_FORM = 'go_to_valuation_form',
  HOW_GO_TO_MY_REAL_ESTATE = 'go_to_my_real_estate',
  CLOSE_UNAVAILABLE_FAVOURITES_BANNER = 'close_unavailable_favourites_banner',
}

export enum InteractionContainerName {
  FAVOURITES_LIST = 'favouritesList',
  HEADER = 'header',
  UNDO = 'undo',
  FAVOURITES_CLICKTHROUGH = 'favourites_clickthrough_favourites',
  FAVOURITES_REMOVE = 'favourites_remove',
  TAB_NAVIGATION = 'tab_navigation',
  HOW_CTA = 'how_cta',
  FAVOURITES = 'favourites',
  TRUE = 'true',
  FALSE = 'false',
}

export enum InteractionElement {
  LINK = 'link',
}

export type TrackingParameterValue =
  | string
  | number
  | boolean
  | undefined
  | InteractionContainerDetail
  | InteractionEvent
  | InteractionGoal
  | InteractionContainerName
  | InteractionElement;

export interface GTMPageViewTrackingParameters {
  h_page_type_110: GTMPageType;
  h_content_language_116: HgSupportedLanguage;

  [additionalParameters: string]: any;
}

export function isGTMEnabled(): boolean {
  return !!window.dataLayer;
}

export function trackEvent(
  eventName: InteractionEvent,
  eventParams: Record<string, TrackingParameterValue> = {},
): void {
  if (!isGTMEnabled()) {
    return;
  }
  window.dataLayer.push({
    ...eventParams,
    event: eventName,
  });
}

export function trackVirtualPageView(
  pageViewTrackingParameters: GTMPageViewTrackingParameters,
  eventParams: Record<string, TrackingParameterValue> = {},
): void {
  trackEvent(InteractionEvent.VIRTUAL_PAGEVIEW, {
    ...eventParams,
    ...pageViewTrackingParameters,
  });
}

export enum ListName {
  FAVOURITES = 'favourites',
}
